import { useState } from 'react';
import { IComponentCss } from '@tap/mui-ui';
import { IApiRelationLink, IApiRelationType } from '@tap/data-providers';
import { Grid, Typography, Button } from '@mui/material';
import { RelationLinkListItem } from './RelationLinkListItem';

/**
 *  Список связанных ссылок (список с группами)
 */

const MAX_SHOW_GROUP_LINK = 2;
const MAX_SHOW_ALL_LINK = 4;


type IRelationLinkListProps = {
    items: IApiRelationLink[],
    handleClickOnDeleteLinkBtn: (link: IApiRelationLink) => void,
}

type IRelationLinkGroup = {
    relationType: IApiRelationType,
    items: IApiRelationLink[],
}

const css: IComponentCss = {
    group: {
        mb: 2,
    },
    groupName: {
        display: 'block',
        textTransform: 'none',
        fontWeight: 700,
        color: '#212121',
        width: '100%',
        paddingBottom: '5px',
        borderBottom: '1px solid #e0e0e0',
    },
}

const groupLinksByType = (items: IApiRelationLink[]): IRelationLinkGroup[] => {
    const result = {} as any;

    items.forEach(link => {
        const groupId = link.relationType.code;
        result[groupId] = result[groupId] || {
            relationType: link.relationType,
            items: [],
        };

        result[groupId].items.push(link);
    });


    return Object.keys(result).map(k => result[k]);
}


export const RelationLinkList = ({
    items,
    handleClickOnDeleteLinkBtn,
}: IRelationLinkListProps) => {

    const [showAll, setShowAll] = useState<boolean>(false);
    const groups = groupLinksByType(items);

    const toggleAllIsEnabled = items.length > MAX_SHOW_ALL_LINK;

    return (
        <>
            {groups.map((group) => (

                <Grid key={group.relationType.code}
                    container
                    sx={css.group}>
                    <Typography sx={css.groupName}>
                        {group.relationType.name}
                    </Typography>
                    {(showAll || !toggleAllIsEnabled ? group.items : group.items.splice(0, MAX_SHOW_GROUP_LINK)).map((item: IApiRelationLink) =>
                        <RelationLinkListItem
                            key={item.id}
                            link={item}
                            handleClickOnDeleteLinkBtn={handleClickOnDeleteLinkBtn}
                        />,
                    )}
                </Grid>

            ))}

            {toggleAllIsEnabled &&
                <Grid container>
                    <Button
                        size='small'
                        disableElevation
                        onClick={() => setShowAll(prev => !prev)}
                    >
                        {showAll ? 'Скрыть' : `Показать всё (${items.length} ссылок)`}
                    </Button>
                </Grid>
            }
        </>
    );
}
